
import { computed, defineComponent, PropType } from "vue";
import CiCompanyTile from "@components/companies/CompanyTile.vue";
import CiProductTile from "@components/products/tile.vue";
import CiInterestTags from "@components/tags/interest-tags.vue";
import CiUserTile from "@components/users/tile.vue";

export default defineComponent({
  name: "CiContentsSidebar",
  components: { CiCompanyTile, CiInterestTags, CiProductTile, CiUserTile },
  props: {
    content: {
      type: Object as PropType<Contents.Content>,
      required: true,
    },
    relatedProducts: {
      type: Array as PropType<Products.TileData[]>,
      required: false,
      default: () => [],
    },
  },
  setup(props) {
    const hasCompanyData = computed(() => !!props.content.company);
    const hasRelatedProducts = computed(() => props.relatedProducts.length);

    return {
      hasCompanyData,
      hasRelatedProducts,
    };
  },
});
